import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PageTitleService {
  private titleSubject = new BehaviorSubject<string>('');
  pageTitle = this.titleSubject.asObservable();

  constructor(private router: Router) {
  }

  public setPageTitle(): void {
    let route = this.router.routerState.snapshot.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    
    this.titleSubject.next(route.data['title']);
  }
}
